// COLORS

export const MUTED_TEXT_COLOR = '#9ea5ab';
export const WARNING_COLOR = '#fc9d79';

export const DEFAULT_DOCUMENT_TITLE = 'App | influence.vision';

export const NO_SEARCH_TOKENS_KEY = 'no_search_tokens';
export const NO_PROFILE_TOKENS_KEY = 'no_profile_tokens';
export const MODAL_LIMITED_KEY = 'modal_limited';
